export default "__VITE_ASSET__A127ye_a__"